import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Parse from "parse";
import Lightbox from "yet-another-react-lightbox";
import Download from "yet-another-react-lightbox/plugins/download";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/styles.css";

import { Card, CardContent, CircularProgress } from "@mui/material";

import WindowTitleComponent from "../WindowTitleComponent";

export default function Album({ album, updateAppTitle }) {
  const [title, setTitle] = useState("Loading...");
  const [status, setStatus] = useState("loading");
  const [photos, setPhotos] = useState([]);
  const [index, setIndex] = useState(-1);

  useEffect(() => {
    let startLoading = async () => {
      let npages = 1;
      let page = 1;

      let allPhotos = [];
      let fail = false;

      while (page <= npages) {
        let data = await Parse.Cloud.run("getFlickrAlbum", {
          album: album,
          page: page,
        });

        if (data.stat === "fail") {
          fail = true;
          break;
        } else if (data.stat === "ok") {
          allPhotos.push(...data.photoset.photo);
          if (page === 1) {
            setTitle(data.photoset.title);
            updateAppTitle(data.photoset.title);
            npages = Math.ceil(data.photoset.total / data.photoset.perpage);
          }
        }
        page += 1;
      }
      setPhotos(allPhotos);
      if (fail) {
        setStatus("fail");
      } else {
        setStatus("ok");
      }
    };

    let currentUser = Parse.User.current();
    if (currentUser) {
      startLoading();
    }
  }, []);

  switch (status) {
    case "loading":
      return (
        <div className="photoloading">
          <CircularProgress />
        </div>
      );

    case "ok":
      const previewTiles = [];
      const lightboxSlides = [];

      for (const [index, item] of photos.entries()) {
        var url =
          "https://farm" +
          item.farm +
          ".staticflickr.com/" +
          item.server +
          "/" +
          item.id +
          "_" +
          item.secret +
          "_q.jpg"; // preview image
        var name = item.title._content;
        var href =
          "https://farm" +
          item.farm +
          ".staticflickr.com/" +
          item.server +
          "/" +
          item.id +
          "_" +
          item.secret +
          "_b.jpg"; // full size image
        previewTiles.push(
          <img
            style={{ height: "150px", width: "150px", margin: "1px" }}
            alt={name}
            src={url}
            key={href}
            onClick={() => setIndex(index)}
          />,
        );
        lightboxSlides.push({
          src: href,
          download: {
            filename: item.title ? item.title : item.id,
          },
        });
      }
      return (
        <div>
          <WindowTitleComponent title={title} />
          <div className="photocontainer">{previewTiles}</div>
          <Lightbox
            index={index}
            slides={lightboxSlides}
            open={index >= 0}
            close={() => setIndex(-1)}
            plugins={[Download, Zoom]}
            zoom={{ maxZoomPixelRatio: 8 }}
            animation={{ swipe: 250 }}
          />
        </div>
      );
      break;

    case "fail":
      return (
        <div>
          <Card className="paper-card login-card">
            <CardContent className="inlog-card">
              <p>
                Dit album bestaat helaas niet, of er is iets anders misgegaan.
                Klik <Link to="/photos">hier</Link> om terug te gaan naar het
                albumoverzicht.
              </p>
            </CardContent>
          </Card>
        </div>
      );

    default:
      return (
        <div>
          <Card className="paper-card login-card">
            <CardContent className="inlog-card">
              <p>
                Er is iets misgegaan. Klik <Link to="/photos">hier</Link> om
                terug te gaan naar het albumoverzicht.
              </p>
            </CardContent>
          </Card>
        </div>
      );
  }
}
